// import {JL} from 'jsnlog'
// JL.setOptions({
//   defaultAjaxUrl: 'https://logger.compratucocheonline.es/jsnlog.logger'
// })
// const internalLogger = JL('main_logger')

let logger = {

  info (text) {
    // if (process.env.NODE_ENV !== 'production') {
    //   console.info(text)
    // } else {
    //   internalLogger.info(text)
    // }
  },

  // eslint-disable-next-line
  error (error) {
    // if (process.env.NODE_ENV !== 'production') {
    //   console.error(error)
    // } else {
    //   internalLogger.error(error)
    // }
  }
}

export {logger}



// WEBPACK FOOTER //
// ./src/utils/Logger.js